import * as React from "react";
import ReactLazyLoad from "react-lazyload";
import { ExtendedContextStore, PageType } from "typings/flexFramework/FlexDefinitions";
import { Experiment, isVariantEnabled } from "components/utility/experiment";

interface LazyLoadProps {
  context?: ExtendedContextStore;
  children: React.ReactElement;
}

// Renders its children only when it is visible to the user
export const LazyLoad: React.FC<LazyLoadProps> & { enabled?: boolean } = ({ context, children }) => {
  if (!children) {
    return null;
  }

  if (!context || !LazyLoad.enabled || !shouldLazyLoad(context)) {
    return children;
  }

  return (
    <ReactLazyLoad once offset={200}>
      {children}
    </ReactLazyLoad>
  );
};

const pageTypesToLazyLoad: PageType[] = [
  "Alternative-Accommodations",
  "Hotel-Destinations",
  "Hotel-Filter-Destinations",
  "Hotel-Information",
  "Hotels-Near",
  "Travel-Guide-Accommodation",
  "Travel-Guide-Filter-Hotels",
  "Travel-Guide-Hotels",
  "Travel-Guide-VacationRentals",
  "Vacation-Rental-Destinations",
];

const shouldLazyLoad = (context: ExtendedContextStore) => {
  if (context.queryParams?.["dynamicRender"] === "1") {
    return true;
  }

  const userAgent = context.userAgent?.toLowerCase() || "";

  // We should not lazy load for bots for SEO purposes
  if (
    userAgent.includes("bot") ||
    userAgent.includes("naver") ||
    userAgent.includes("catchpoint") ||
    userAgent.includes("screaming frog")
  ) {
    return false;
  }

  return (
    isVariantEnabled(context, Experiment.Blossom_Dynamic_Render) ||
    isVariantEnabled(context, Experiment.ILL21) ||
    pageTypesToLazyLoad.includes(context.searchContext?.pageType)
  );
};

// Global flag to turn on/off for testing purposes
LazyLoad.enabled = true;
